import { useState } from 'react';
/** Window only the table; callers retain the complete list for drawers. */ export function useShowMore(rows, resetKey = '') {
    const [window, setWindow] = useState({
        key: resetKey,
        count: 100
    });
    const count = window.key === resetKey ? window.count : 100;
    return {
        visible: rows.slice(0, count),
        hasMore: count < rows.length,
        showMore: ()=>setWindow({
                key: resetKey,
                count: count + 100
            })
    };
}
